<mat-form-field>
  <button
    mat-icon-button
    matPrefix
    aria-label="Remove"
    [color]="color"
    (click)="onClickIncrementValue(-step)"
    [disabled]="shouldDisableDecrement(value)">
    <mat-icon>remove</mat-icon>
  </button>
  <input matInput
         type="number"
         (focus)="color='primary'"
         (blur)="color='default'"
         [value]="symbol ? valueSymbol : value"
         [disabled]="isDisabled"
         type="text"
         (input)="onInput($event.target['value'])"/>
  <button
    mat-icon-button
    matSuffix
    aria-label="Add"
    [color]="color"
    (click)="onClickIncrementValue(step)"
    [disabled]="shouldDisableIncrement(value)">
    <mat-icon>add</mat-icon>
  </button>
</mat-form-field>
